<script setup lang="ts">
import { REGULAR_EXPEDITIONS, INSTANT_EXPEDITIONS } from '~/shared/expedition'

const props = withDefaults(
  defineProps<{
    title?: string
    path?: string
    withInstantCourier?: boolean
  }>(),
  {
    title: 'Pilihan Ekspedisi yang Tersedia',
    path: '/cekaja',
    withInstantCourier: false
  }
)

const expeditions = computed(() => {
  if (props.withInstantCourier) {
    return [...REGULAR_EXPEDITIONS, ...INSTANT_EXPEDITIONS]
  }
  return REGULAR_EXPEDITIONS
})
</script>

<template>
  <section class="py-10">
    <UiContainer class="py-5 flex flex-col gap-6 lg:gap-10">
      <UiSectionTitle class="text-center" variant-size="small" :title="title" />
      <div class="flex flex-wrap items-center justify-center gap-3">
        <UiCourierCard
          v-for="(expedition, index) in expeditions"
          :key="index"
          :code="expedition.code"
          :company-name="expedition.company_name"
          :icon="expedition.icon"
          :class="expedition.class"
          :to="`${path}/${expedition.code}`"
        />
      </div>
    </UiContainer>
  </section>
</template>
